/**
 * useTranscription Hook
 * Manages transcription-only flow
 */

import { useState, useCallback } from 'react';
import { transcribeFile } from '../services/api.service';

export function useTranscription() {
  const [transcription, setTranscription] = useState('');
  const [metadata, setMetadata] = useState(null);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);

  const transcribe = useCallback(async (file) => {
    setLoading(true);
    setProgress(0);
    setError(null);
    setTranscription('');

    try {
      const result = await transcribeFile(file, (prog) => {
        setProgress(prog);
      });

      setTranscription(result.data.transcription);
      setMetadata(result.metadata);
      setProgress(100);
      
      return result;
    } catch (err) {
      setError(err.message || 'Transcription failed');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setTranscription('');
    setMetadata(null);
    setLoading(false);
    setProgress(0);
    setError(null);
  }, []);

  /**
   * Set transcription data directly (for loading from history)
   * @param {string} text - Transcription text
   * @param {Object} meta - Metadata
   */
  const setTranscriptionData = useCallback((text, meta = null) => {
    setTranscription(text);
    setMetadata(meta);
    setProgress(100);
    setError(null);
  }, []);

  return {
    transcription,
    metadata,
    loading,
    progress,
    error,
    transcribe,
    reset,
    setTranscriptionData
  };
}
